const RTL_LANGS = ['ar'];
class Helper {
  static isLanguageRTL(lng: string) {
    return RTL_LANGS.indexOf(lng) !== -1;
  }

  static languageDirection(language: string) {
    const rtl = Helper.isLanguageRTL(language);
    return rtl ? 'rtl' : 'ltr';
  }
}

export default Helper;
